<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="inspectionKLMVo.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="1200px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="inspectionKLMVo"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <div class="vm-separate">
          <el-form-item label="出厂编号">
            <el-input v-model="inspectionKLMVo.factoryNo" readonly placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="sap订单号">
            <el-input v-model="inspectionKLMVo.sapOrderNo" readonly placeholder="请输入"/>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item label="客户合同号">
            <el-input v-model="inspectionKLMVo.clientContractNo" readonly placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="订单类型">
            <el-input v-model="inspectionKLMVo.orderType" readonly placeholder="请输入"/>
          </el-form-item>
        </div>
        <el-form-item label="备注">
          <el-input
              v-model="inspectionKLMVo.note"
              type="textarea"
              autosize
              readonly/>
        </el-form-item>
        <div style="padding: 0 0 10px 10px;width: 90%;margin: 0 auto">
          <el-table
              :data="inspectionKLMVo.details">
            <el-table-column type="index" label="序号" align="center" width="55"/>
            <el-table-column prop="materialNo" align="center" label="物料编号"/>
            <el-table-column prop="materialName" align="center" label="物料名称"/>
            <el-table-column prop="inspectMode" align="center" label="所属模块">
              <template slot-scope="scope">
                <el-select v-model="scope.row.inspectMode" clearable placeholder="请选择">
                  <el-option label="散件/井道其他物料" :value="10"/>
                  <el-option label="控制柜" :value="20"/>
                  <el-option label="操纵" :value="30"/>
                  <el-option label="外呼" :value="40"/>
                  <el-option label="轿顶" :value="50"/>
                  <el-option label="线系统" :value="60"/>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="note" align="center" label="备注">
              <template slot-scope="scope">
                <el-input v-model="scope.row.note" type="textarea"/>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">订单附件</div>
          <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;margin: 10px 0 10px 0">
            <el-upload
                :action="actionUrl"
                :on-success="handleSuccess"
                :on-remove="handleRemove"
                :on-error="handlerError"
                :file-list="files"
                :show-file-list="false">
              <el-button size="small" type="primary" style="margin: 0 5px 0 0">添加附件</el-button>
            </el-upload>
          </div>
          <el-table
              v-if="inspectionKLMVo.attachments"
              ref="payData1"
              :data="inspectionKLMVo.attachments">
            <el-table-column type="index" align="center" label="行号"/>
            <el-table-column prop="fileName" align="center" label="附件描述">
              <template slot-scope="scope">
                <el-input v-model="scope.row.fileName" class="tabInput" style="width: 400px;margin: 0 auto;text-align: center"/>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="60" class-name="vm-table_operate">
              <template slot-scope="scope">
                <el-button type="danger" @click="fileDelete(scope.row,scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "@/util/constant";

  export default {
    name: "InspectionKLMEdit",
    components: {},
    data() {
      return {
        constant,
        actionUrl: window.config.basicServerHttpUrl + "file/upload",
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        files: [],
        inspectionKLMVo: {
          factoryNo: "",
          orderType: "",
          sapOrderNo: "",
          clientContractNo: "",
          note: "",
          attachments: [],
          details: [],
        },
        ruleValidate: {
          customerName: {required: true, message: "客户名称不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        console.log(row);
        this.inspectionKLMVo = row;
        if (row.orderId>0) {
          this.getMaterials(row.orderId);
        }
        this.dialogVisible = true;
      },
      getMaterials(orderId) {
        this.contentLoading = true;
        this.$http
          .get("basic", `shipmentInspectKlms/getOrderDetails/${orderId}`)
          .then(resp => {
            this.inspectionKLMVo.details = resp;
            this.contentLoading = false;
          });
      },
      selectCustomer(row) {
        console.log(row);
        this.inspectionKLMVo.customerName = row.customerName;
        this.inspectionKLMVo.customerId = row.customerID;
      },
      fileDelete(row,index) {
        console.log(row);
        this.inspectionKLMVo.attachments.splice(index,1);
      },
      handlerError(err, file, fileList) {
        console.log(file);
        console.log(fileList);
        alert(err);
      },
      //物料表页面删除
      oneDelete(row, index) {
        this.inspectionKLMVo.materialList.splice(index, 1);
      },
      handleSuccess(response, file, fileList) {
        file.path = response;
        this.files = fileList;
        let object ={
          fileName:file.path.originalName,
          filePath:file.path.fullPath,
        };
        this.inspectionKLMVo.attachments.push(object);
      },
      handleRemove(file, fileList) {
        this.files = fileList;
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            if (this.inspectionKLMVo.pkid > 0) {
              this.$http
                .put("basic", "inspectionKLMVos/saveVo", this.inspectionKLMVo)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            } else {
              this.inspectionKLMVo.complaintDate = null;
              this.$http
                .post("basic", "inspectionKLMVos", this.inspectionKLMVo)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
